import React from "react";

type LogoutModalProps = {
  onProceed: () => void;
  onCancel: () => void;
  isOpen: boolean;
};

const LogoutModal: React.FC<LogoutModalProps> = ({
  onProceed,
  onCancel,
  isOpen,
}) => {
  return (
    <>
      {isOpen && (
        <div className="absolute inset-0 z-[99] flex items-center justify-center bg-black/50 w-full h-screen">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 absolute z-50">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Logout</h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to logout?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onCancel();
                }}
                className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onProceed();
                }}
                className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                id="unsavedModalProceed"
                next-tab=""
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LogoutModal;
